import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Environment } from 'src/environments/environment';

import { Crop, GetCropsResponse } from '../models';

@Injectable({
  providedIn: 'root',
})
export class CropService {
  private readonly http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  private baseUrl = `${this.env.APIM_BASE_URL}/arable-service/crop`;

  getCrops(): Observable<Crop[]> {
    return this.http.get<GetCropsResponse>(this.baseUrl).pipe(map((d) => d.crops));
  }
}
